// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4659":"539e8166","6594":"c8eb5545","7135":"cf1ea8bd","8313":"c8eb5545"}[chunkId] + ".chunk.css";
};